var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.625C11.4498 3.625 12.625 4.80025 12.625 6.25C12.625 7.69975 11.4498 8.875 10 8.875C8.55025 8.875 7.375 7.69975 7.375 6.25C7.375 4.80025 8.55025 3.625 10 3.625Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 11.5416H6.95117C7.05186 11.5416 7.15211 11.5573 7.24805 11.5885L7.96973 11.8248C9.28914 12.2556 10.7118 12.2556 12.0312 11.8248L12.752 11.5885C12.8481 11.5572 12.9489 11.5416 13.0498 11.5416H13.334C14.7836 11.5418 15.959 12.717 15.959 14.1666V15.1569C15.959 15.5394 15.6814 15.8657 15.3037 15.9274C11.7915 16.5008 8.2095 16.5008 4.69727 15.9274C4.31958 15.8657 4.04199 15.5395 4.04199 15.1569V14.1666C4.04199 12.7169 5.21724 11.5416 6.66699 11.5416Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.21b4ec5bd828b516aa7d040a9eb67d53.svg";
export { ForwardRef as ReactComponent };